import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Header extends Vue {
  @Prop()
  private blur = false

  private header!: HTMLElement

  public mounted () {
    let thisHeader = this.header
    thisHeader = this.$refs.header as HTMLElement

    window.addEventListener('scroll', () => {
      if (document.body.scrollTop > 70 || document.documentElement.scrollTop > 70) {
        thisHeader.className = 'small'
      } else {
        thisHeader.className = ''
      }
    })
  }
}
